var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("connection-settings-popup", {
    attrs: {
      "is-new": _vm.isNew,
      config: { dateField: _vm.dateField, offset: _vm.offset },
      validations: _vm.$options.validations,
      "comment-id": _vm.commentId,
      resources: {
        deletePromptTitle: _vm.resource("JourneyBuilder_Delay_Delete_Title"),
        deletePromptBody: _vm.resource("JourneyBuilder_Delay_Delete_Body"),
        deleteButtonText: _vm.resource(
          "JourneyComposer_JourneyBrickMenu_Delay_Button_DeleteCheckpoint"
        )
      }
    },
    on: {
      save: function($event) {
        return _vm.save()
      },
      delete: function($event) {
        return _vm.deleteCheckpoint()
      },
      "display-errors": function($event) {
        return _vm.displayErrors()
      },
      hidden: function($event) {
        return _vm.$emit("hidden")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.resource(
                    "JourneyBuilder_JourneyBrickMenu_Delay_DisplayName"
                  )
                )
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("h4", [
              _vm._v(
                _vm._s(
                  _vm.resource("JourneyBuilder_JourneyBrick_SettingsHeader")
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("div", [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.resource(
                          "JourneyBuilder_FilterSettings_Offset_Column"
                        )
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "form-control mb-2",
                  attrs: {
                    placeholder: "Applicable date field",
                    options: _vm.offsetDateColumns,
                    disabled: !_vm.canWrite
                  },
                  model: {
                    value: _vm.dateField,
                    callback: function($$v) {
                      _vm.dateField = $$v
                    },
                    expression: "dateField"
                  }
                }),
                _vm._v(" "),
                _c("time-period", {
                  attrs: { showBeforeAfter: "", disabled: !_vm.canWrite },
                  model: {
                    value: _vm.offset,
                    callback: function($$v) {
                      _vm.offset = $$v
                    },
                    expression: "offset"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.$v.$dirty && _vm.$v.$invalid
              ? _c("error-message", {
                  attrs: {
                    message: _vm.resource(
                      "JourneyBuilder_Delay_DateFieldOrPeriodRequired_Message"
                    )
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("div", [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.resource("JourneyBuilder_Moment_WeekdayToSend")
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "form-control mb-2",
                  attrs: {
                    options: _vm.daysOfTheWeek,
                    clearable: false,
                    "close-on-select": "",
                    disabled: !_vm.canWrite
                  },
                  model: {
                    value: _vm.weekDay,
                    callback: function($$v) {
                      _vm.weekDay = $$v
                    },
                    expression: "weekDay"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }